module.exports = __webpack_public_path__ + "img/billing-policy.ad0586b3.png";